class MessageAudioPanel extends MessageFilePanel {
  // constructor(attachment, message) {
  // 	super(attachment, message, 'messaging-message-audio');
  // 	this.$attachment.input('audio').attr('src', `/detail/content/${attachment.id}/${attachment.fileName}`)
  // }
}

MessagePanel.registerFileType(MessageAudioPanel, "wav");
